import React from 'react';
import { clsx } from 'clsx';

export const GlassInput = React.forwardRef(({ className, type = 'text', ...props }, ref) => {
  return (
    <input
      type={type}
      className={clsx('glass-input', className)}
      ref={ref}
      {...props}
    />
  );
});

GlassInput.displayName = 'GlassInput';

export const GlassSelect = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <select
      className={clsx('glass-input glass-select', className)}
      ref={ref}
      {...props}
    >
      {children}
    </select>
  );
});

GlassSelect.displayName = 'GlassSelect';

export const GlassTextarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={clsx('glass-input glass-textarea', className)}
      ref={ref}
      {...props}
    />
  );
});

GlassTextarea.displayName = 'GlassTextarea';
